import React, { useState } from "react";
import SelectIcon from '@fishx/select-icon';
import { getLocale } from '@utils/util';

const Container = ({ defaultIcon, onConfirm }) => {
  const messages = getLocale();
  const [icon, setIcon] = useState(defaultIcon || '');

  const handleClick = (selectIcon) => {
    setIcon(selectIcon);
    onConfirm(selectIcon);
  }
  return (
    <SelectIcon
      icon={icon}
      iconClick={handleClick}
      placeholder={messages['PAGEBUIDER_PLS_SELECT']}
      titleText={messages['PAGEBUIDER_PLS_SELECT_ICON']}
      typeText={[
        messages['PAGEBUIDER_ICON_TYPE_NORMAL'],
        messages['PAGEBUIDER_ICON_TYPE_OUTLINED'],
        messages['PAGEBUIDER_ICON_TYPE_FILLED'],
        messages['PAGEBUIDER_ICON_TYPE_TWO_TONE']
      ]}
      sortText={[
        messages['PAGEBUIDER_ICON_SORT_DIRECTION_ICON'],
        messages['PAGEBUIDER_ICON_SORT_TIPS_ICON'],
        messages['PAGEBUIDER_ICON_SORT_EDIT_ICON'],
        messages['PAGEBUIDER_ICON_SORT_NORMAL_ICON']
      ]}
    />
  )
}

export default Container;